import './App.css';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import HotSideBar from './components/HotSidebar';
import RecommendSideBar from './components/RecommendSidebar';
import React, { useState, useEffect, useRef } from 'react';
import { Flex, Layout, Table, Row, Col, Checkbox } from 'antd';
import unit from './unit';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

// 股东类型映射配置
const typeConfig = {
  'institution': {
    title: '知名机构-实时揭露机构持仓明细+成本_仓位在线',
    keywords: '机构,增持,减持,成本价,成本,盈亏',
    description: '仓位在线知名机构频道为投资者提供最新机构持仓明细+持仓成本数据，通过对机构增持、减持、新进股票的持仓比例+持仓成本的深入分析，快速做出正确的投资决策。'
  },
  'niusan': {
    title: '牛散-实时揭露牛散持仓明细+成本_仓位在线',
    keywords: '牛散,游资,成本,盈亏,增持',
    description: '仓位在线牛散频道为投资者提供最新牛散持仓明细+持仓成本数据，通过对牛散增持、减持、新进股票的持仓比例+持仓成本的深入分析，紧跟游资大佬步伐，不错过牛股爆发的时机'
  },
  'fund': {
    title: '金牛基金-实时揭露基金持仓明细+成本_仓位在线',
    keywords: '基金,公募基金,私募基金,ETF,场内基金,场外基金',
    description: '仓位在线金牛基金频道为投资者提供最新基金持仓明细+持仓成本数据，通过对基金增持、减持、新进股票的持仓比例+持仓成本的深入分析，紧跟明星基金的操作，赚取超额收益'
  },
  'nationalteam': {
    title: '国家队-实时揭露国家队持仓明细+成本_仓位在线',
    keywords: '国家队,中央汇金,社保,社保基金',
    description: '仓位在线国家队频道为投资者提供最新国家队持仓明细+持仓成本数据，通过对国家队增持、减持、新进股票的持仓比例+持仓成本的深入分析，可把握未来大行情趋势'
  },
  'foreigncapital': {
    title: '外资-实时揭露外资持仓明细+成本_仓位在线',
    keywords: '外资,qfii',
    description: '仓位在线外资频道为投资者提供最新外资持仓明细+持仓成本数据，通过对外资增持、减持、新进股票的持仓比例+持仓成本的深入分析，跟随国际投行的操作可稳重求胜'
  }
};

// 新增：路径参数与数字的映射关系
const typeMap = {
  'institution': 1,
  'niusan': 2,
  'fund': 3,
  'nationalteam': 4,
  'foreigncapital': 5
};

// 新增：数字到路径参数的反向映射
const reverseTypeMap = {
  1: 'institution',
  2: 'niusan',
  3: 'fund',
  4: 'nationalteam',
  5: 'foreigncapital'
};

const { Content } = Layout;

const List = (props) => {
  const [page, setPage] = useState(1);
  const [name, setName] = useState('');
  const [tips, setTips] = useState('');
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const childRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { type } = useParams(); // 获取路径参数
  
  const [sortField, setSortField] = useState('stock_num');
  const [sortOrder, setSortOrder] = useState('descend');
  const [total, setTotal] = useState(0);
  const [lastClickedIndex, setLastClickedIndex] = useState(null);
  const [filterOrigin, setFilterOrigin] = useState(true);   // 默认选中
  const [filterEtf, setFilterEtf] = useState(true);   // 默认开启

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: '股东名称',
      dataIndex: 'name',
      key: 'name',
      className: 'gudong',
      render: (text, record) => (
        // 使用路径参数替代查询参数
        <a href={`/detail/${record.code}`} target="_blank">
          {text}
        </a>
      ),
    },
    {
      title: '持股数量',
      dataIndex: 'stock_num',
      key: 'stock_num',
      sorter: true,
      align: 'center',
      defaultSortOrder: 'descend',
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '持仓市值',
      dataIndex: 'stock_value',
      key: 'stock_value',
      sorter: true,
      align: 'center',
      sortDirections: ['descend', 'ascend'],
    },
  ];

  // 修改：使用映射关系将路径参数转换为数字类型
  const getDetailList = (
  typeParam,
  page = 1,
  pagesize = 50,
  sortField = 'stock_num',
  sortOrder = 'desc',
  filterOrigin = true,   // 仅 niusan 有效
  filterEtf = true       // 仅 fund   有效
) => {
  const numericType = typeMap[typeParam] || typeParam;
  const path = '/pc/gudong/getGudongList';

  // 基础参数
  const params = {
  "type": numericType,
      "page": page,
      "pageSize": pagesize,
      "apiversion": "8.9",
      "sortField": sortField,
      "sortOrder": sortOrder
  };

  // 仅 niusan 把 filterOrigin 带上去
  if (typeParam === 'niusan') {
    params.filterOrigin = filterOrigin ? 1 : 0;
  }
  // 仅 fund 把 filterEtf 带上去
  if (typeParam === 'fund') {
    params.filterEtf = filterEtf ? 1 : 0;
  }

  unit.httpGet(path, params, (data) => {
    let dataSource = [];
    setTotal(data.count);
    setName(data.name);
    setTips(data.tips);
    if (data.list.length > 0) {
      const startIdx = (page - 1) * pagesize;
      dataSource = data.list.map((item, i) => ({
        index: startIdx + i + 1,
        code: item.code,
        name: item.name,
        stock_num: item.stock_num,
        stock_value: unit
          .bigNumberTransform(item.stock_value)
          .replace(/(\d+\.\d+)千亿/, (_, p1) => `${(p1 * 1000).toFixed(0)}亿`)
          .replace(/(\d+\.\d+)千万/, (_, p1) => `${(p1 * 1000).toFixed(0)}万`),
      }));
    }
    setDataSource(dataSource);
    setLoading(false);
  });
};

  const handleTableChange = (pagination, filters, sorter) => {
    setSortField(sorter.field);
    setSortOrder(sorter.order);
    setPage(pagination.current);
    getDetailList(type, pagination.current, 50, sorter.field, sorter.order === 'ascend' ? 'asc' : 'desc', filterOrigin);
  };

  useEffect(() => {
    if (type) {
      getDetailList(type);
      updateMetaInfo(type);
    }
  }, [type]);

  useEffect(() => {
    if (type) {
      // 保持当前分页、排序条件
      getDetailList(type, page, 50, sortField, sortOrder === 'ascend' ? 'asc' : 'desc', filterOrigin, filterEtf);
    }
  }, [type, page, sortField, sortOrder, filterOrigin, filterEtf]);  // 依赖里加上 filterOrigin, filterEtf

  // 更新页面元信息
  const updateMetaInfo = (type) => {
    const config = typeConfig[type] || typeConfig['institution'];
    
    // 设置页面标题
    document.title = config.title;
    
    // 设置keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', config.keywords);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'keywords');
      newMeta.setAttribute('content', config.keywords);
      document.head.appendChild(newMeta);
    }
    
    // 设置description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', config.description);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'description');
      newMeta.setAttribute('content', config.description);
      document.head.appendChild(newMeta);
    }
  };

  const onRow = (record, index) => {
    return {
      onClick: (event) => {
        let code = record.code;
        localStorage.setItem('selectedCode', code);
        setLastClickedIndex(index);
        // 使用路径参数导航
        //navigate(`/detail/${code}`);
      },
    };
  };

  const customRowClassName = (record, index) => {
    if (index === lastClickedIndex) {
      return 'last-clicked-row';
    }
    return '';
  };

  // 监听 type 变化，不再需要刷新整个页面
  useEffect(() => {
    const lastType = localStorage.getItem('lastType');
    if (type !== lastType) {
      localStorage.setItem('lastType', type);
      // 重置分页状态
      setPage(1);
      getDetailList(type);
      updateMetaInfo(type);
    }
  }, [type]);

  return (
    <div className="App">
      <Flex gap="middle" wrap>
        <Layout>
          <HeaderComponent ref={childRef}></HeaderComponent>
          <Content>
            <div className='body'>
              <Row>
                <Col span={18} style={{ background: "#FFFFFF", borderRadius: "7px 7px 7px 7px" }}>
                  <div className='row'>
                    <div className='left title'>{name}名单</div>
                    <div className='left tips'>{tips}</div>
                    <div className='right update_time'>
                      {type === 'niusan' && (
                        <Checkbox
                          checked={filterOrigin}
                          onChange={(e) => setFilterOrigin(e.target.checked)}
                          style={{ marginRight: 16 }}
                        >
                          过滤原始股东
                        </Checkbox>
                      )}

                      {type === 'fund' && (
                        <Checkbox
                          checked={filterEtf}
                          onChange={(e) => setFilterEtf(e.target.checked)}
                          style={{ marginRight: 16 }}
                        >
                          过滤 ETF / 指数基金
                        </Checkbox>
                      )}
                    </div>
                    <div className='clear'></div>
                  </div>
                  <div className='table' >
                    <Table
                      size='small'
                      loading={loading}
                      locale={{ cancelSort: "点击取消排序", triggerAsc: "点击升序", triggerDesc: "点击降序", emptyText: "暂无数据" }}
                      onRow={(record, index) => onRow(record, index)}
                      pagination={{
                        current: page,
                        pageSize: 50,
                        total: total,
                        showSizeChanger: false,
                        showQuickJumper: true,
                        locale: {
                          jump_to: '跳至',
                          jump_to_confirm: '确定',
                          page: '页',
                          prev_page: '上一页',
                          next_page: '下一页'
                        }
                      }}
                      columns={columns}
                      dataSource={dataSource}
                      rowClassName={(record, index) => customRowClassName(record, index)}
                      onChange={handleTableChange}
                      sortField={sortField}
                      sortOrder={sortOrder}
                      total={total}
                    ></Table>
                  </div>
                </Col>
                <Col span={6}>
                  <div className='sidebar-container'>
                    {/* 传递 type 作为路径参数 */}
                    <HotSideBar type={type} />
                    <div style={{ marginTop: "15px" }}></div>
                    <RecommendSideBar type={type} />
                  </div>
                </Col>
              </Row>
            </div>
          </Content>
          <FooterComponent></FooterComponent>
        </Layout>
      </Flex>
    </div>
  );
};

export default List;